import { restEventCommonParams } from '@/common/converter/const'
import { getOnInstantPlay } from '@/common/converter/utils/get-event-property'

/**
 * instant play catalog 의 경우 테스트 필요
 * @param elementList
 * @returns {{add_timestamp: string, method: string, contenttype: string, add_common_params: string, bodylist, contentid: string, add_credential: string, type: string}|undefined}
 */
export const convertEventOnInstantPlay = (elementList = []) => {
  const { type, contentId, contentType, method, bodyList, isRender } =
    getOnInstantPlay(elementList)

  if (!isRender) return undefined

  return {
    type,
    method,
    contentid: contentId,
    contenttype: contentType,
    bodylist: bodyList,
    ...restEventCommonParams,
  }
}
